export default {
  filters: {
    today: 'I dag',
    yesterday: 'I går',
    this_week: 'Denne uge',
    last_week: 'Sidste uge',
    this_month: 'Denne måned',
    last_month: 'Sidste måned',
    all: 'Alle',
  },
};
